import VueRouter from 'vue-router'
import Vue from 'vue'

// 下面4行代码解决在当前页面跳转当前路由浏览器控制台报错问题，参考https://blog.csdn.net/cll1224666878/article/details/107062586/ 
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/helloword',
		name: 'helloword',
		component: () => import('../components/HelloWorld.vue')
	},
	{
		path: '/test1',
		name: 'test1',
		component: () => import('../test/test1.vue')
	},
	{
		path: '/test2',
		name: 'test2',
		component: () => import('../test/test2.vue')
	},
	/* 本项目路由开始 */
	{
		path: '/',
		redirect: 'index'
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('../views/index.vue'),
		meta: {title: '强企宝典首页_深度探索企业成功之路-专家问询的焦点问题，影响企业持续经营的潜在隐患，焦点问题解决方案'}
	},
	{
		path: '/index_old',
		name: 'index_old',
		component: () => import('../views/index_old.vue'),
		meta: {title: '强企宝典首页_深度探索企业成功之路-专家问询的焦点问题，影响企业持续经营的潜在隐患，焦点问题解决方案'}
	},
	{
		path: '/list',
		name: 'list',
		component: () => import('../views/list.vue'),
		meta: {title: '列表页'}
	},
	{
		path: '/detail',
		name: 'detail',
		component: () => import('../views/detail.vue'),
		meta: {title: '详情页'}
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login.vue'),
		meta: {title: '登录/注册_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/search',
		name: 'search',
		component: () => import('../views/search.vue'),
		meta: {title: '搜索_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/statis',
		name: 'statis',
		component: () => import('../views/idx_statis.vue'),
		meta: {title: '数据分析_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/daohang',
		name: 'daohang',
		component: () => import('../views/idx_daohang.vue'),
		meta: {title: '成长导航_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/zhichan',
		name: 'zhichan',
		component: () => import('../views/idx_zhichan.vue'),
		meta: {title: '知识产权_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/fengxian',
		name: 'fengxian',
		component: () => import('../views/idx_fengxian.vue'),
		meta: {title: '风险管控_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_article',
		name: 'detail_article',
		component: () => import('../views/detail_article.vue'),
		meta: {title: '图文详情_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_daohang',
		name: 'list_daohang',
		component: () => import('../views/list_daohang.vue'),
		meta: {title: '成长导航_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_zhichan',
		name: 'list_zhichan',
		component: () => import('../views/list_zhichan.vue'),
		meta: {title: '知识产权_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_fengxian',
		name: 'list_fengxian',
		component: () => import('../views/list_fengxian.vue'),
		meta: {title: '风险管控_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_biaogan',
		name: 'list_biaogan',
		component: () => import('../views/list_biaogan.vue'),
		meta: {title: '标杆企业_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_biaogan_transfer',
		name: 'list_biaogan_transfer',
		component: () => import('../views/list_biaogan_transfer.vue'),
		meta: {title: '标杆企业_转换_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_company',
		name: 'detail_company',
		component: () => import('../views/detail_company.vue'),
		meta: {title: '企业详情_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_company_prosp_sp',
		name: 'detail_company_prosp_sp',
		component: () => import('../views/detail_company_prosp_sp'),
		meta: {title: '招股说明书详情_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_fengxian',
		name: 'list_statis_fengxian',
		component: () => import('../views/list_statis_fengxian.vue'),
		meta: {title: '风险因素统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_fengxian_filter',
		name: 'list_statis_fengxian_filter',
		component: () => import('../views/list_statis_fengxian_filter.vue'),
		meta: {title: '风险因素统计_根据关键词过滤_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_wenda',
		name: 'list_statis_wenda',
		component: () => import('../views/list_statis_wenda.vue'),
		meta: {title: '问询答复统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_wenda_filter',
		name: 'list_statis_wenda_filter',
		component: () => import('../views/list_statis_wenda_filter.vue'),
		meta: {title: '问询答复统计_根据关键词过滤_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_qiye',
		name: 'list_statis_qiye',
		component: () => import('../views/list_statis_qiye.vue'),
		meta: {title: '标杆企业数据统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zhichan',
		name: 'list_statis_zhichan',
		component: () => import('../views/list_statis_zhichan.vue'),
		meta: {title: '知识产权数据统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zzhc_jixiao',
		name: 'list_statis_zzhc_jixiao',
		component: () => import('../views/list_statis_zzhc_jixiao.vue'),
		meta: {title: '标杆企业数据统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zzhc_wenda',
		name: 'list_statis_zzhc_wenda',
		component: () => import('../views/list_statis_zzhc_wenda.vue'),
		meta: {title: '问询答复统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zzhc_wenda_filter',
		name: 'list_statis_zzhc_wenda_filter',
		component: () => import('../views/list_statis_zzhc_wenda_filter.vue'),
		meta: {title: '问询答复统计_根据关键词过滤_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zzhc_fengxian',
		name: 'list_statis_zzhc_fengxian',
		component: () => import('../views/list_statis_zzhc_fengxian.vue'),
		meta: {title: '风险因素统计_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_statis_zzhc_fengxian_filter',
		name: 'list_statis_zzhc_fengxian_filter',
		component: () => import('../views/list_statis_zzhc_fengxian_filter.vue'),
		meta: {title: '风险因素统计_根据关键词过滤_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_wenda',
		name: 'list_wenda',
		component: () => import('../views/list_wenda.vue'),
		meta: {title: '问询答复_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/list_wenda_transfer',
		name: 'list_wenda_transfer',
		component: () => import('../views/list_wenda_transfer.vue'),
		meta: {title: '问询答复_转换_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_wenda_list',
		name: 'detail_wenda_list',
		component: () => import('../views/detail_wenda_list.vue'),
		meta: {title: '问询答复_列表_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_wenda_sp',
		name: 'detail_wenda_sp',
		component: () => import('../views/detail_wenda_sp.vue'),
		meta: {title: '问询答复详情_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/detail_wenda',
		name: 'detail_wenda',
		component: () => import('../views/detail_wenda.vue'),
		meta: {title: '问询答复详情_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/user_collection',
		name: 'user_collection',
		component: () => import('../views/user_collection.vue'),
		meta: {title: '我的收藏_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/user_payment',
		name: 'user_payment',
		component: () => import('../views/user_payment.vue'),
		meta: {title: '我的订单_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/user_invoice',
		name: 'user_invoice',
		component: () => import('../views/user_invoice.vue'),
		meta: {title: '我的发票_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/user_uinfo',
		name: 'user_uinfo',
		component: () => import('../views/user_uinfo.vue'),
		meta: {title: '我的信息_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/pay',
		name: 'pay',
		component: () => import('../views/pay.vue'),
		meta: {title: '支付费用_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/pay10',
		name: 'pay10',
		component: () => import('../views/pay10.vue'),
		meta: {title: '支付费用_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/pay11',
		name: 'pay11',
		component: () => import('../views/pay11.vue'),
		meta: {title: '支付费用_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/pay12',
		name: 'pay12',
		component: () => import('../views/pay12.vue'),
		meta: {title: '支付费用_强企宝典-深度探索企业成功之路'}
	},
	{
		path: '/pay19',
		name: 'pay19',
		component: () => import('../views/pay19.vue'),
		meta: {title: '支付费用_强企宝典-深度探索企业成功之路'}
	}
]

const router = new VueRouter({
	routes: routes,
	// mode: 'history'
})

export default router
